<template>
  <el-form-item
    ref="rangeDateTime"
    prop="rangeDateTime"
    :label="label"
    class="date-time-range"
    :rules="rules"
  >
    <el-form
      :inline="true"
      :model="form"
    >
      <el-form-item
        ref="rangeDateTimeInner"
        prop="rangeDateTimeInner"
        :rules="rules"
      >
        <el-date-picker
          v-model="rangeDateTime"
          type="datetimerange"
          format="yyyy/MM/dd HH:mm"
          value-format="yyyy/MM/dd HH:mm"
          :range-separator="rangeSeparator"
          :start-placeholder="startPlaceholder"
          :end-placeholder="endPlaceholder"
          :disabled="disabled"
          :autofocus="autofocus"
        />
      </el-form-item>
    </el-form>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    value: Object,
    label: String,
    dateTimeFrom: String,
    dateTimeTo: String,
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    rangeSeparator: {
      type: String,
      default: '～'
    },
    startPlaceholder: {
      type: String,
      default: 'yyyy/MM/dd HH:mm'
    },
    endPlaceholder: {
      type: String,
      default: 'yyyy/MM/dd HH:mm'
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        rangeDateTimeInner: [
          this.dateTimeFrom,
          this.dateTimeTo
        ]
      }
    }
  },
  computed: {
    rangeDateTime: {
      get () {
        return ['' + this.dateTimeFrom, '' + this.dateTimeTo]
      },
      set (rangeDateTime) {
        this.$set(this.form, 'rangeDateTimeInner', rangeDateTime)
        var dateTimeFrom = ''
        var dateTimeTo = ''
        if (rangeDateTime) {
          [dateTimeFrom, dateTimeTo] = rangeDateTime
        }
        this.$emit('update:dateTimeFrom', dateTimeFrom)
        this.$nextTick(() => {
          this.$emit('update:dateTimeTo', dateTimeTo)
        })
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
        }
        return rules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      const form = this.$el.querySelector('.el-form')
      const div = document.createElement('div')
      const formItem = form.firstChild
      div.appendChild(formItem)
      form.parentNode.appendChild(div)
      form.remove()
      const rangeInputArray = formItem.querySelectorAll('.el-range-input')
      rangeInputArray.forEach((x) => {
        x.setAttribute('maxlength', '16')
      })
      this.$refs.rangeDateTime.validate = this.$refs.rangeDateTimeInner.validate
      this.$refs.rangeDateTime.clearValidate = this.$refs.rangeDateTimeInner.clearValidate
      this.$refs.rangeDateTime.resetField = this.$refs.rangeDateTimeInner.resetField
    })
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  &.date-time-range {
    .el-input__inner {
        width: 46em;
    }
  }
}
</style>
